import React, { useEffect, useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import {
  Card,
  Container,
  Row,
  Col,  
  CardHeader,
  CardBody,
} from "reactstrap";
import { MIDTIDProfile, MonthlyVolumeTransactions, WeeklyVolumeTransactions } from "./components";
import { MDBIcon } from "mdbreact";
import axios from "utils/api";
import "styles/_dashboard.scss";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: '100%',
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const Dashboard = () => {
  const classes = useStyles();
  const [chartType, setChartType] = useState('weekly');

  useEffect(() => {
    let mounted = true;

    if (mounted) {
      const authSession = JSON.parse(localStorage.getItem('auth'));

      var auditlog = { 
        moduleName: 'Dashboard',
        accountId: authSession?.merchantGroupCode,
        username: authSession?.username,
        actionsTaken: 'Viewed dashboard'
      };

      axios.post('auditlog/add', { auditlog: auditlog }).then((response) => { });
    }

     return () => {
      mounted = false;
    };
  },[]);

  const handleFrequencyChange = (event) => {
    setChartType(event.target.value);
  }

  const handleChange = (event) => {
    const authSession = JSON.parse(localStorage.getItem('auth'));

    var auditlog = { 
      moduleName: `Dashboard > ${event.target.value.charAt(0).toUpperCase() + event.target.value.slice(1)} Transaction Volume`,
      accountId: authSession?.merchantGroupCode,
      username: authSession?.username,
      actionsTaken: `Viewed ${event.target.value} transaction volume`
    };

    axios.post('auditlog/add', { auditlog: auditlog }).then((response) => { });

    setChartType(event.target.value);
  }

  document.body.style.overflow = 'visible';
  
  return (
    <>
    <div className="header bg-gradient-info pb-8 pt-5 pt-md-8">
      <div className="page-header">
        <h1>Dashboard</h1>
        <h3>List of weekly/monthly transaction volumes and merchant profiles.</h3>
        <p>
        <MDBIcon icon="link" fixed />  Dashboard 
        </p>
      </div>
      <Container>
        <Row>
          <div className="col">
            <Row>
              <Col md="12" xs="12">
                <Card className="card-stats mb-4 mb-xl-0 shadow">
                  <CardHeader className="border-0">
                    <Row>
                      <Col>
                      <h3 className="mb-0">Transaction Volume</h3>
                      </Col>
                      <Col>
                        <div style={{float: 'right'}}>
                          <label style={{marginRight: '20px'}}>
                            <input
                              type="radio"
                              value="weekly"
                              checked={chartType === "weekly"}
                              onChange={handleFrequencyChange}
                            /> Weekly Transaction
                          </label>
                          <label>
                            <input
                              type="radio"
                              value="monthly"
                              checked={chartType === "monthly"}
                              onChange={handleFrequencyChange}
                            /> Monthly Transaction
                          </label>
                          
                        </div>
                      </Col>
                    </Row>
                  </CardHeader>
                  <hr className="mt--2 divider" />
                  <CardBody className="mt--4">
                    { chartType === 'weekly' ? <WeeklyVolumeTransactions /> : <MonthlyVolumeTransactions /> }
                  </CardBody>              
                </Card>
              </Col>
            </Row>
          </div>
        </Row>
        <br />
        <MIDTIDProfile/>
      </Container>
    </div>
  </>
  );
}

export default Dashboard;
